import { QueryParams } from 'common/urls/QueryParams';
import React, { useCallback } from 'react';
import { Toggle } from 'src/shared/design-system/Toggle';
import { useTrackFilterChange } from '../hooks/useTrackFilterChange';
import { SECTION_TEXT } from './consts';
import { Section } from './styles';
import { FilterProps } from './types';

export const EcoPackaging: React.FC<FilterProps> = ({ filters }) => {
  const { updateQueryParams, ecoFilter } = filters;
  const { trackFilterChange } = useTrackFilterChange({ filters });
  const handleClick = useCallback(() => {
    const updates = { [QueryParams.ECO_FILTER]: !ecoFilter };
    updateQueryParams(updates);
    trackFilterChange(updates);
  }, [updateQueryParams, ecoFilter, trackFilterChange]);

  return (
    <Section.Container>
      <Section.Header>{SECTION_TEXT.ECO.HEADER}</Section.Header>
      <Section.Wrapper>
        <Section.ToggleContainer>
          <Toggle checked={ecoFilter} onChange={handleClick} />
        </Section.ToggleContainer>
      </Section.Wrapper>
    </Section.Container>
  );
};
